'use client';

import React from 'react';
import * as SubframeUtils from '../utils';

interface StatsCardCustomProps {
  label: React.ReactNode;
  value: React.ReactNode;
  icon?: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  trendLabel?: string;
  noIconWrapper?: boolean;
}

interface StatsCardRootProps
  extends
    Omit<React.HTMLAttributes<HTMLDivElement>, keyof StatsCardCustomProps>,
    StatsCardCustomProps {}

const StatsCardRoot = React.forwardRef<HTMLDivElement, StatsCardRootProps>(function StatsCardRoot(
  { label, value, icon, trend, trendLabel, noIconWrapper = false, className, ...otherProps },
  ref,
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        'bg-default-background flex w-full flex-col items-start gap-1 rounded-[16px] border border-solid border-neutral-200 px-6 py-5',
        className,
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex w-full items-center gap-2">
        {icon && !noIconWrapper && (
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-neutral-50">
            {icon}
          </div>
        )}
        {icon && noIconWrapper && icon}
        <span className="text-caption-bold font-caption-bold text-subtext-color tracking-wider uppercase">
          {label}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-heading-1 font-heading-1 text-default-font">{value}</span>
        {trendLabel && (
          <span
            className={SubframeUtils.twClassNames(
              'text-[11px] leading-none font-medium',
              trend === 'up'
                ? 'text-success-600'
                : trend === 'down'
                  ? 'text-error-600'
                  : 'text-neutral-500',
            )}
          >
            {trendLabel}
          </span>
        )}
      </div>
    </div>
  );
});

export const StatsCard = StatsCardRoot;
